import { render, staticRenderFns } from "./newCost.vue?vue&type=template&id=48dd8521&scoped=true&"
import script from "./newCost.vue?vue&type=script&lang=js&"
export * from "./newCost.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./newCost.vue?vue&type=style&index=1&id=48dd8521&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dd8521",
  null
  
)

export default component.exports